export const progressbar = {
  colorScheme: {
    light: {
      height: '8px',
      background: '#e6f7f3',
      value: {
        background: '#14a08c',
      },
    },
    dark: {
      height: '8px',
      background: '#e6f7f3',
      value: {
        background: '#14a08c',
      },
    },
  },
};
